export default {
  name: "Preparer",
  prefix: "I",
  pageInfo: {
    text: `Complete this section if the preparer of this application is a person other than the one identified in either Section D (employer point of contact) or section E (attorney or agent) of this application.`,
    coloring: `grey`,
  },
  sections: [
    {
      fields: [
        {
          code: "I.1",
          machine_name: "prepLastname",
          widget: "text",
          label: "Last (family) name",
          maxLength: 35,
          tooltip:
            "Enter the last (family) name of the person preparing this application by or on behalf of the employer.",
          validate: [
            {
              valueChecker: "prepLastname",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "prepLastname",
                  "prepFirstname",
                  "prepFein",
                  "prepBizname",
                  "prepEmail",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
        },
        {
          code: "I.2",
          machine_name: "prepFirstname",
          widget: "text",
          label: "First (given) name",
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the person preparing this application by or on behalf of the employer.",
          validate: [
            {
              valueChecker: "prepFirstname",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "prepLastname",
                  "prepFirstname",
                  "prepFein",
                  "prepBizname",
                  "prepEmail",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
        },
        {
          code: "I.3",
          machine_name: "prepMiddlename",
          widget: "text",
          label: "Middle Initial",
          maxLength: 3,
          tooltip:
            "If applicable, enter the middle initial of the person preparing this application by or on behalf of the employer. If the preparer does not have a middle name, enter “N/A.”",
        },
        {
          code: "I.4",
          machine_name: "prepFein",
          widget: "text",
          label: "Law Firm/Business FEIN",
          maxLength: 10,
          tooltip:
            "Enter the FEIN, assigned by the IRS, for the firm or business submitting this application by or on behalf of the employer. If not applicable, leave blank.",
          parse: "fein",
          validate: [
            {
              valueChecker: "prepFein",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "prepLastname",
                  "prepFirstname",
                  "prepFein",
                  "prepBizname",
                  "prepEmail",
                ],
                check: "ifValueExists",
              },
            },
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
          ],
        },
        {
          code: "I.5",
          machine_name: "prepBizname",
          widget: "text",
          label: "Law Firm/Business Name",
          maxLength: 120,
          tooltip:
            "Enter the name of the firm or business that prepared this application by or on behalf of the employer.",
          validate: [
            {
              valueChecker: "prepBizname",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "prepLastname",
                  "prepFirstname",
                  "prepFein",
                  "prepBizname",
                  "prepEmail",
                ],
                check: "ifValueExists",
              },
            },
            {
              minLength: 5,
              message: "Legal Business Name must contain at least 5 characters",
            },
          ],
        },
        {
          code: "I.6",
          machine_name: "prepEmail",
          widget: "text",
          label: "Law Firm/Business Email Address",
          validate: [
            {
              valueChecker: "prepEmail",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: [
                  "prepLastname",
                  "prepFirstname",
                  "prepFein",
                  "prepBizname",
                  "prepEmail",
                ],
                check: "ifValueExists",
              },
            },
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 100,
          tooltip: `Enter the business email address of the person that prepared this application by or on behalf of the employer. 
          Format must be in the format name@emailaddress.top-level domain. The email entered in this field must be the one regularly used 
          by the preparer to send and receive electronic communications from the Department with respect to the processing of this application. 
          If the preparer does not possess a business email address, please enter “N/A.”`,
        },
      ],
    },
  ],
};
